import React from 'react';
import { MapPinIcon, PhoneIcon } from 'lucide-react';
export function AreasWeServe() {
  const cities = ['Ann Arbor', 'Birmingham', 'Bloomfield Hills', 'Bloomfield Township', 'Canton', 'Commerce', 'Farmington', 'Farmington Hills', 'Keego Harbor', 'Livonia', 'Northville', 'Northville Township', 'Novi', 'Orchard Lake', 'Plymouth', 'Redford', 'Southfield', 'Walled Lake', 'West Bloomfield', 'Wixom', 'Metro Detroit Area'];
  return <section className="relative py-20 bg-cover bg-center" style={{
    backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/2jvcFvK4rZFLtsJoPUZMEy/image.png)'
  }} data-id="element-388">
      {/* Light white overlay for readability */}
      <div className="absolute inset-0 bg-white/85" data-id="element-389"></div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4" data-id="element-390">
        <div className="max-w-5xl mx-auto text-center" data-id="element-391">
          {/* Map Pin Icon */}
          <div className="flex justify-center mb-4" data-id="element-392">
            <div className="bg-[#B1050B] w-16 h-16 rounded-full flex items-center justify-center" data-id="element-393">
              <MapPinIcon size={32} className="text-white" data-id="element-394" />
            </div>
          </div>

          {/* Title */}
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-395">
            Areas We Serve
          </h2>

          {/* SEO Paragraph */}
          <p className="text-lg text-gray-700 mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-396">
            Garrett Auto & Truck Service, Inc provides auto repair, truck
            repair, diesel engine repair, fleet maintenance, and DOT inspections
            for drivers and businesses across the Detroit Metro area. Located at
            24175 Industrial Park Dr., Farmington Hills, MI 48335, we're an easy
            drive from many nearby communities. If you need reliable repairs,
            diagnostics, or preventative maintenance, our shop is ready to help.
          </p>

          {/* City Chips */}
          <div className="flex flex-wrap justify-center gap-3 mb-8" data-id="element-397">
            {cities.map(city => <div key={city} className="flex items-center bg-white border-2 border-gray-300 rounded-full px-5 py-2.5 shadow-sm hover:border-[#B1050B] hover:shadow-md transition-all" data-id="element-398">
                <MapPinIcon size={16} className="mr-2 text-[#B1050B]" data-id="element-399" />
                <span className="text-sm font-medium text-gray-800" data-id="element-400">
                  {city}
                </span>
              </div>)}
          </div>

          {/* Secondary SEO Line */}
          <p className="text-sm text-gray-600 mb-8 italic" data-id="element-401">
            Serving Southeast Michigan with dependable automotive and commercial
            truck service since 1958.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-402">
            <a href="tel:2484788382" className="flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-403">
              <PhoneIcon size={20} className="mr-2" data-id="element-404" />
              Call Now
            </a>
            <a href="https://maps.google.com/?q=24175+Industrial+Park+Dr.,+Farmington+Hills,+MI+48335" target="_blank" rel="noopener noreferrer" className="flex items-center bg-white hover:bg-gray-50 text-[#B1050B] border-2 border-[#B1050B] px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-405">
              <MapPinIcon size={20} className="mr-2" data-id="element-406" />
              Get Directions
            </a>
          </div>
        </div>
      </div>
    </section>;
}